import {
  TablePage,
  AddPage,
  EditPage,
  ViewPage,
} from 'src/views/aciair/ssr'
import pathMap from 'src/paths/pathMap'

class AciAirRoute {
  getConfigurations() {
    return [
      {
        exact: true,
        path: pathMap.ACI_AIR_SSR_LIST_VIEW,
        component: TablePage
      },
      {
        exact: true,
        path: pathMap.ACI_AIR_SSR_ADD_VIEW,
        component: AddPage
      },
      {
        exact: true,
        path: pathMap.ACI_AIR_SSR_EDIT_VIEW,
        component: EditPage
      },
      {
        exact: true,
        path: pathMap.ACI_AIR_SSR_DETAILS_VIEW,
        component: ViewPage
      }
    ]
  }
}

export default AciAirRoute
